module.exports = __webpack_public_path__ + "img/copyLink.0d990306.svg";